import { Injectable } from "@angular/core";
import { Product } from "src/app/modals/product.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CartItem } from "src/app/modals/cart-item";
import { map } from "rxjs/operators";
import { Observable, BehaviorSubject, Subscriber } from "rxjs";
import { AlertServiceService } from "src/app/services/alerta.service";
import { MatDialogRef } from "@angular/material";
import { ProductDialogComponent } from "../../shop/products/product-dialog/product-dialog.component";

// Get product from Localstorage
let products = JSON.parse(localStorage.getItem("cartItem")) || [];
let costoEnvio = 0;
@Injectable({
  providedIn: "root",
})
export class CartService {
  // Array
  public cartItems: BehaviorSubject<CartItem[]> = new BehaviorSubject([]);
  public observer: Subscriber<{}>;

  constructor(
    public snackBar: MatSnackBar,
    private alert: AlertServiceService
  ) {
    this.cartItems.subscribe((products) => (products = products));
  }

  // Get Products
  public getItems(): Observable<CartItem[]> {
    const itemsStream = new Observable((observer) => {
      observer.next(products);
      observer.complete();
    });
    return <Observable<CartItem[]>>itemsStream;
  }

  // Add to cart
  public addToCart(product: Product, quantity: number) {
    // console.log(product)
    if (product.PV2 == 0) {
      this.snackBar.open(
        "No se puede añadir este item al carrito de compras... No tiene precio de venta Tarjeta ",
        "×",
        { panelClass: "error", verticalPosition: "bottom", duration: 3000 }
      );
      return;
    }
    let message, status;
    var item: CartItem | boolean = false;
    // If Products exist
    let hasItem = products.find((items, index) => {
      if (items.product.idItem == product.idItem) {
        let qty = products[index].quantity + quantity;
        let stock = this.calculateStockCounts(products[index], quantity);
        if (qty != 0 && stock) {
          products[index]["quantity"] = qty;
          message = product.NombreItm + " ha sido agregado al carrito.";
          status = "success";
        }
        return true;
      }
    });

    // If Products does not exist (Add New Products)
    if (!hasItem) {
      item = { product: product, quantity: quantity };
      products.push(item);
      message = product.NombreItm + " ha sido a agregado al carrito.";
      status = "success";
    }

    localStorage.setItem("cartItem", JSON.stringify(products));
    return item;
  }

  // Calculate Product stock Counts
  public calculateStockCounts(item: CartItem, quantity): CartItem | Boolean {
    let message, status;
    let qty = item.quantity + quantity;
    let stock = item.product.SaldoG;
    if (stock < qty) {
      // this.toastrService.error('You can not add more items than available. In stock '+ stock +' items.');
      // this.snackBar.open(
      //   "No puedes elegir más artículos de los disponibles. En stock " +
      //     stock +
      //     " items.",
      //   "×",
      //   { panelClass: "error", verticalPosition: "bottom", duration: 3000 }
      // );
      return false;
    }
    return true;
  }

  // Removed in cart
  public removeFromCart(item: CartItem) {
    if (item === undefined) return false;
    const index = products.indexOf(item);
    // console.log(item)
    products.splice(index, 1);
    localStorage.setItem("cartItem", JSON.stringify(products));
  }

  public removeAll() {
    sessionStorage.removeItem("idPedidoGen");
    sessionStorage.removeItem("dataPedido");
    localStorage.removeItem("cartItem");
  }

  // Total amount

  public getTotalAmount(): Observable<number> {
    return this.cartItems.pipe(
      map((product: CartItem[]) => {
        return products.reduce((prev, curr: CartItem) => {
          // ////console.log(curr)
          // costoEnvio = JSON.parse(localStorage.getItem("costoEnvio"));
          return prev + curr.product.PVVenta * curr.quantity;
        }, 0);
      })
    );
  }

  // Update Cart Value
  public updateCartQuantity(
    product: Product,
    quantity: number
  ): CartItem | boolean {
    return products.find((items, index) => {
      if (items.product.idItem == product.idItem) {
        let qty = products[index].quantity + quantity;
        let stock = this.calculateStockCounts(products[index], quantity);
        if (qty != 0 && stock) products[index]["quantity"] = qty;
        localStorage.setItem("cartItem", JSON.stringify(products));
        return true;
      }
    });
  }
}
